import React from "react";
import Icon from "./Icon";
import RewardVisual from "./RewardVisual";

export default function KidRewardGoal({ reward, balance, selected, onBrowse }) {
  if (!reward) return null;
  const remaining = Math.max(0, reward.cost - balance);
  const pct = reward.cost > 0 ? Math.min(100, Math.max(0, balance / reward.cost * 100)) : 100;
  return <section className="reward-goal" data-testid="kid-reward-goal" aria-label="Reward goal">
    <div className="goal-art"><RewardVisual reward={reward} context="kid" color="#a78bfa" size={94} /></div>
    <div className="goal-copy">
      <span className="quest-section-label">{selected ? "ON YOUR WISHLIST" : "SOMETHING TO AIM FOR"}</span>
      <h3>{reward.title}</h3>
      <div className="goal-meter" role="progressbar" aria-label={`Progress toward ${reward.title}`} aria-valuenow={pct} aria-valuemin={0} aria-valuemax={100}><span style={{ width: `${pct}%` }} /></div>
      <p>{remaining ? <><strong>{remaining} more coins</strong> to request it</> : <><Icon name="check" width={13} height={13} /> Ready to request!</>}</p>
    </div>
    <button onClick={onBrowse} type="button" className="goal-browse" data-testid="kid-goal-browse" aria-label="Browse rewards and choose your goal"><Icon name="arrow-up-right" width={19} height={19} /></button>
  </section>;
}
